import { NextPageContext } from "next";

import { BaseServerSideProps } from "src/utilities/ssr/baseServerSideProps";
import { addCacheControl } from "src/utilities/ssr/caching";
import { validateAndDecodeParam } from "src/utilities/ssr/validateAndDecodeParam";

export const getNonprofitOrUserServerSideProps =
  (
    getNonprofitProps?: (slug: string) => Promise<BaseServerSideProps>,
    getUserProps?: (slug: string) => Promise<BaseServerSideProps>
  ) =>
  async (ctx: NextPageContext) => {
    const slug = validateAndDecodeParam(ctx, "nonprofitSlugOrUsername").trim();
    const isNonprofit = !slug.startsWith("@");

    const props = { slug, isNonprofit };

    // Not on server, do nothing - let client-side data fetching handle this
    if (!ctx.res || !ctx.req) {
      return { props };
    }

    // Cache this SSR response at edge
    addCacheControl(ctx);

    if (isNonprofit) {
      // Nonprofit Page
      if (!getNonprofitProps) {
        return { props };
      }
      try {
        const data = await getNonprofitProps(slug);

        // Redirect to primary slug
        const primarySlug = data.initialData?.nonprofits?.[0].primarySlug;
        if (primarySlug && slug !== primarySlug) {
          const slugAtStart = new RegExp(`^/${slug}`);
          const location =
            ctx.req.url?.replace(slugAtStart, `/${primarySlug}`) ||
            `/${primarySlug}`;

          ctx.res.statusCode = 302;
          ctx.res.setHeader("Location", location);
          return { props };
        }
        const initialData = {
          ...data.initialData,
        };
        return { props: { ...props, ...data, initialData } };
      } catch (error) {
        ctx.res.statusCode = 404;
        return { props };
      }
    }

    // User Page
    if (!getUserProps) {
      return { props };
    }
    const data = await getUserProps(slug);
    const initialData = {
      ...data.initialData,
    };
    return { props: { ...props, ...data, initialData } };
  };
